import React from 'react';
import moment from 'moment';

import { DATE_TIME_FORMAT } from '../../constants';
import ConfirmModal from 'components/ConfirmModal/ConfirmModal';
import Spinner from 'components/Spinner';
import { getError } from 'helpers/errors';
import FormError from 'components/FormError';
import AddNoteModal from 'components/modals/AddNoteModal';

class NoteList extends React.Component {
  state = {
    loading: false,
    loadingNotes: false,
    openPinConfirmation: false,
    pinIdInProgress: null,
    pinError: '',
    unpinError: '',
    isOpenAddNote: false,
  };

  handleOpenAddNote = () => {
    this.setState({ isOpenAddNote: true });
  };

  handleCloseAddNote = () => {
    this.setState({ isOpenAddNote: false });
  };

  handleOpenPinConfirmation = (id) => {
    this.setState({
      openPinConfirmation: true,
      pinIdInProgress: id,
    });
  };

  handlePinClicked = (id) => {
    const { notes } = this.props;
    const note = notes.find((n) => n.id === id);
    if (note.pinned) {
      this.unpinNote(id);
    } else {
      this.handleOpenPinConfirmation(id);
    }
  };

  unpinNote = (id) => {
    const { updateNote } = this.props;
    this.setState({ loadingNotes: true, pinError: '', unpinError: '' });

    updateNote(id, { pinned: false })
      .then(() => {
        this.setState({ unpinError: '', loadingNotes: false });
      })
      .catch((e) => {
        const error = getError(e);
        this.setState({ unpinError: error, loadingNotes: false });
      });
  };

  pinNote = () => {
    const { pinIdInProgress } = this.state;
    const { notes, updateNote, notesFirstPageAlways } = this.props;
    if (!pinIdInProgress || !updateNote) {
      return;
    }

    const newPinnedNote = notes.find((note) => note.id === pinIdInProgress);
    const oldPinnedNote =
      notesFirstPageAlways && notesFirstPageAlways.find((note) => note.pinned);

    this.setState({ loading: true, pinError: '', unpinError: '' });

    let promise;
    if (oldPinnedNote) {
      promise = updateNote(oldPinnedNote.id, { pinned: false }).then(() =>
        updateNote(newPinnedNote.id, { pinned: true }),
      );
    } else {
      promise = updateNote(newPinnedNote.id, { pinned: true });
    }
    promise
      .then(() => {
        this.closeConfirmation();
      })
      .catch((e) => {
        const error = getError(e);
        this.setState({ pinError: error, loading: false });
      });
  };

  closeConfirmation = () => {
    this.setState({
      openPinConfirmation: false,
      pinIdInProgress: null,
      pinError: '',
      loading: false,
    });
  };

  getConfirmText = () => {
    const { pinIdInProgress } = this.state;
    const { notes } = this.props;
    if (!pinIdInProgress) {
      return '';
    }

    const pinnedNote = notes.find((note) => note.id === pinIdInProgress);

    return `Are you sure you want to pin note: "${pinnedNote.id} - ${pinnedNote.text}"?`;
  };

  render() {
    const {
      userId,
      subId,
      carrier,
      notes = [],
      showPinNote,
      createNote,
      fetchNotes,
    } = this.props;
    const {
      openPinConfirmation,
      loading,
      loadingNotes,
      pinError,
      unpinError,
      isOpenAddNote,
    } = this.state;
    return (
      <div id="notes-list" style={{ position: 'relative' }}>
        <div className="d-flex-vc mar-t">
          <h3 style={{ margin: '0px 20px 0px 0px' }}>Notes</h3>
          <button className="btn btn-default" onClick={this.handleOpenAddNote}>
            Add Note
          </button>
        </div>
        {unpinError && (
          <div className="mar-t">
            <FormError error={unpinError} />
          </div>
        )}
        <table className="table">
          <thead>
            <tr>
              {showPinNote && <th>Pin</th>}
              <th>ID</th>
              <th>Author</th>
              <th>Text</th>
              <th>AT&T Sub</th>
              <th>Simo Sub</th>
              <th>Quick Sub</th>
              <th>Sprint Sub</th>
              <th>TracFone Sub</th>
              <th>Created At</th>
            </tr>
          </thead>
          <tbody>
            {notes.length > 0 &&
              notes.map((note) => (
                <tr key={note.id}>
                  {showPinNote && (
                    <td>
                      <img
                        src={`/images/icons/pins/${note.pinned ? 'pin-icon' : 'pin-line-icon'}.png`}
                        alt=""
                        style={{
                          width: '16px',
                          height: '16px',
                          cursor: 'pointer',
                        }}
                        onClick={() => this.handlePinClicked(note.id)}
                      />
                    </td>
                  )}
                  <td>{note.id}</td>
                  <td>{note.author}</td>
                  <td>{note.text}</td>
                  <td>{note.att_subscription}</td>
                  <td>{note.simo_subscription}</td>
                  <td>{note.quick_subscription}</td>
                  <td>{note.subscription}</td>
                  <td>{note.tracfone_subscription}</td>
                  <td>{moment(note.created_at).format(DATE_TIME_FORMAT)}</td>
                </tr>
              ))}
            {notes.length === 0 ? (
              <tr>
                <td colSpan="6">No notes yet</td>
              </tr>
            ) : null}
          </tbody>
        </table>
        <ConfirmModal
          isOpen={openPinConfirmation}
          onConfirm={this.pinNote}
          onClose={this.closeConfirmation}
          title="Confirm note pinning"
          description={this.getConfirmText()}
          className="notes-confirm-pin-note"
          content={
            <React.Fragment>
              {pinError && <FormError error={pinError} />}
              <Spinner showLoader={loading} />
            </React.Fragment>
          }
          closeOnConfirmClick={false}
        />
        <AddNoteModal
          isOpen={isOpenAddNote}
          userId={userId}
          onClose={this.handleCloseAddNote}
          createNote={createNote}
          fetchNotes={fetchNotes}
          subId={subId}
          carrier={carrier}
        />
        <Spinner showLoader={loadingNotes} />
      </div>
    );
  }
}

export default NoteList;
